export default "__VITE_ASSET__CsGsVfag__"